import { Box } from '@mui/material'
import { t } from 'i18next'


const NoMatch = () => {
  return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 50 }}>404 {t('common.noMatch')}</Box>
}

export default NoMatch
